import { render, staticRenderFns } from "./ProcesoCapacitacion.vue?vue&type=template&id=6cd92ebe&"
import script from "./ProcesoCapacitacion.vue?vue&type=script&lang=js&"
export * from "./ProcesoCapacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports